import Component from '../../components/component/component';

import './progress.scss';

import './import/progress-background-320.jpg';
import './import/progress-background-640.jpg';
import './import/progress-background-1280.jpg';
import './import/progress-background-2560.jpg';

export default class Progress extends Component {
    static initSelector: string = '.js-progress';

    constructor(target: HTMLElement) {
        super(target);

        this.init();
    }

    init(): void {
        this.element.addClass('progress--completed');
        this.element.addClass('progress--upcoming');
    }
}
